import styles from "./HelpBanner.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import roseImage from "@images/rouwadvertentiemaken/rose_purple.png";

/**
 * "Hulp nodig", placed just above the footer
 */
export default () => {
  return <div className={'container'}>
    <div className={styles.banner}>
      <img src={roseImage} alt="" className={styles.image} />
      <div className={styles.text}>
        <h3 className={styles.title}>Hulp nodig of advies op maat?</h3>
        <p className={styles.subtitle}>Wij staan voor je klaar. Bel of mail ons gerust.</p>
      </div>
      <div className={styles.actions}>
        <a href={'tel:0888005707'} className={'btn'} data-sa-location="hulp_banner">
          <FontAwesomeIcon icon={faPhone} className={styles.icon} />
          088-8005707
        </a>
        <a href={'mailto:krant@rouwadvertentiemaken.nl'} className={'btn btn-link'} data-sa-location="hulp_banner">
          <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
          krant@rouwadvertentiemaken.nl
        </a>
      </div>
    </div>
  </div>
}
